var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntypoSocialLinkedinWithCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.498.898c-11.93 0-21.6 9.67-21.6 21.6 0 11.93 9.67 21.6 21.6 21.6 11.93 0 21.6-9.67 21.6-21.6 0-11.93-9.67-21.6-21.6-21.6zm-5.287 30.553h-4.374V17.375h4.374v14.076zm-2.214-15.804c-1.382 0-2.275-.979-2.275-2.19 0-1.234.92-2.184 2.331-2.184 1.41 0 2.275.95 2.302 2.185 0 1.21-.891 2.19-2.358 2.19zm18.189 15.804h-4.374v-7.8c0-1.816-.635-3.05-2.216-3.05-1.209 0-1.926.835-2.244 1.639-.117.285-.146.69-.146 1.093v8.116H19.83v-9.585a94.05 94.05 0 0 0-.115-4.491h3.8l.2 1.955h.088c.576-.918 1.987-2.272 4.347-2.272 2.878 0 5.036 1.928 5.036 6.072v8.323z",
    fill: "#0A66C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntypoSocialLinkedinWithCircle);
export default __webpack_public_path__ + "static/media/entypo-social_linkedin-with-circle.41ffa77335e99bbeef99c5aee85d8184.svg";
export { ForwardRef as ReactComponent };